import { render, staticRenderFns } from "./RestaurantsTabLinks.vue?vue&type=template&id=0395c973"
import script from "./RestaurantsTabLinks.vue?vue&type=script&lang=js"
export * from "./RestaurantsTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports